import { render, staticRenderFns } from "./TabLikes.vue?vue&type=template&id=473e7908&"
import script from "./TabLikes.vue?vue&type=script&lang=ts&"
export * from "./TabLikes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports